export default __webpack_public_path__ + "static/media/Nissan.a0fdb359.svg";